import { jsonVidModifiers } from "@blings/blings-player";
import { uploadFileToS3 } from "../utils/uploadFileToS3";
import { LooseObject } from "../types";
import { getCDN } from "../utils/consts";

export let uploadAssetsPromises: any;
export async function uploadAssets(
  self: any,
  filesToUpload: {
    data: string | undefined;
    file: File;
    ext: string;
    hash: string;
    assetName: string;
  }[],
  assetType: string,
  progressCallback?: any
) {
  const totalSize = filesToUpload.reduce((previousValue, currentValue) => {
    if (!currentValue.data) {
      return previousValue + currentValue.file.size;
    } else if (typeof currentValue.data) {
      // Calculate size of a base64 string (remove the prefix before decoding)
      const str = currentValue.data.split(",")[1];
      let length = (str.length / 4) * 3;
      if (str[str.length - 1] === "=") length--;
      if (str[str.length - 2] === "=") length--;
      return previousValue + length;
    }
    return previousValue;
  }, 0);

  const dataLoaded = Array(filesToUpload.length).fill(0);
  const uploads: { res: { key: string }; name: string }[] = [];
  uploadAssetsPromises = filesToUpload.map((asset, index) =>
    uploadFileToS3(
      self.getFullUrlOfAsset(
        `${asset.hash}_${asset.assetName}`,
        `${assetType}s`
      ),
      {
        file: asset.file,
        stringData: asset.data?.split(",")[1], //remove prefix of base64 meta
      },
      `${assetType}/${asset.ext}`,
      (progress) => {
        dataLoaded[index] = progress.loaded;
        progressCallback(
          dataLoaded.reduce((prev, curr) => prev + curr, 0) / totalSize
        );
      }
    )
  );
  const uploadAssets = Promise.all(uploadAssetsPromises);
  try {
    const uploadAssetsRes = await uploadAssets;
    uploadAssetsRes.forEach((res: any, i: number) => {
      uploads.push({ res, name: filesToUpload[i].assetName });
    });
  } catch (error) {
    console.log(`Could not upload ${assetType}s`); //TODO add this error to user interface
  }
  const assetChanges = uploads.reduce((o, { res, name }) => {
    o[name] = `${getCDN()}/${res.key}`;
    return o;
  }, {} as LooseObject);

  const updatedJson = jsonVidModifiers.changeAssets(
    self.compJson,
    assetChanges
  );

  self.setCompJson(updatedJson);
}
